import React from 'react'
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async"; // ✅ ADD THIS
import Banner from '../Components/Banner'
import pattern from '../Assets/careerbannerpattern.png'
import Breadcrumb from '../Components/Breadcrumb'
import Serviceabout from './../Components/Services/Serviceabout';
import MilestoneSection from './../Components/Services/Milestone/MilestoneSection';
import SpecializedCoursesCarousel from './../Components/Services/ServiceWhyChoose/SpecializedCoursesCarousel';
import endtoend from '../Assets/why-choose-us/end-to-end-guidence.jpg'
import Expert from '../Assets/why-choose-us/Expert councilars.jpg'
import Personalized from '../Assets/why-choose-us/personalised-services.jpg'
import Affordable from '../Assets/why-choose-us/Affordable-option.jpg'
import Global from '../Assets/why-choose-us/Global Reach.jpg'
import ServicesLastAbout from './../Components/Services/ServicesLastAbout';
import { motion } from "framer-motion";
import { getPageMeta } from "./MetaTags";

const coursesList = [
  {
    img: endtoend,
    title: "End-to-End Guidance",
    desc: "From career counselling to settling in after arrival, we cover every stage."
  },
  {
    img: Expert,
    title: "Expert Counselors",
    desc: "Highly experienced career coach online and in-person experts."
  },
  {
    img: Personalized,
    title: "Personalized Service",
    desc: "Each student gets a tailored action plan"
  },
  {
    img: Affordable,
    title: "Affordable Options",
    desc: "Including free career counselling sessions for those in need."
  },
  {
    img: Global,
    title: "Global Reach",
    desc: "Partnerships with universities across USA, Canada, UK, Australia, Europe, and Asia."
  }
];

const Services = () => {

  const isMobile = window.innerWidth < 768;
  const location = useLocation();
  const pageMeta = getPageMeta(location.pathname);

  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  };

  const MotionDiv = ({ children }) =>
    isMobile ? <div>{children}</div> : (
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={fadeUp}
      >
        {children}
      </motion.div>
    );

  // ✅ SCHEMA FOR SERVICES PAGE
  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Service",
        "name": "Study Abroad Consultancy Services",
        "provider": {
          "@type": "EducationalOrganization",
          "name": "Nova EduBridge",
          "url": "https://novaedubridge.com/"
        },
        "areaServed": {
          "@type": "Place",
          "name": "Bangalore, India"
        },
        "serviceType": [
          "Career Counselling",
          "University Selection",
          "Application Assistance",
          "Visa Guidance",
          "Test Preparation",
          "Pre Departure Support"
        ],
        "description": "Nova EduBridge offers complete study abroad services including counselling, admissions, visa assistance, and test preparation."
      },

      {
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "What services does Nova EduBridge provide?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "We provide career counselling, university selection, application support, visa assistance, and pre-departure guidance."
            }
          },
          {
            "@type": "Question",
            "name": "Do you provide visa assistance?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, we offer complete visa counselling and documentation support."
            }
          },
          {
            "@type": "Question",
            "name": "Do you help with IELTS, TOEFL, and PTE?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, we provide coaching and preparation support for IELTS, TOEFL, and PTE exams."
            }
          },
          {
            "@type": "Question",
            "name": "Is counselling free?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "We offer free initial counselling sessions for students."
            }
          }
        ]
      }
    ]
  };

  return (
    <>
      {/* ✅ SCHEMA ADDED HERE */}
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      </Helmet>

      <div>
        {/* Banner */}
        <MotionDiv>
          <Banner
            className='position-relative'
            subtitle="Our Services"
             title={pageMeta.h1 || "Shaping Futures, One Journey Abroad"}
            buttonText="Avail FREE counselling"
            buttonLink="/Contact"
            backgroundImage="/images/about-banner.png"
          />
          <div className='position-absolute pattern'>
            <img src={pattern} alt='pattern' />
          </div>
        </MotionDiv>

        {/* Breadcrumb */}
        <MotionDiv>
          <Breadcrumb />
        </MotionDiv>

        {/* Service About */}
        <MotionDiv>
          <Serviceabout />
        </MotionDiv>

        {/* Milestone */}
        <MotionDiv>
          <MilestoneSection />
        </MotionDiv>

        {/* Why Choose */}
        <MotionDiv>
          <SpecializedCoursesCarousel
            title="Why Choose Us?"
            subtitle=""
            courses={coursesList}
            seeAllLink="/courses"
          />
        </MotionDiv>

        {/* Final Section */}
        <MotionDiv>
          <ServicesLastAbout />
        </MotionDiv>
      </div>
    </>
  );
}

export default Services;
